import LegalPage from '../components/LegalPage'

export default function Dpa() {
  return <LegalPage type="DPA" />
}
